const translations = {
    loading: 'Loading...',
    name: 'Name',
    noMoreFields: 'No more fields'
};

export default translations;
